/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EHopeApprenantSearchType } from './EHopeApprenantSearchType';
import {
    EHopeApprenantSearchTypeFromJSON,
    EHopeApprenantSearchTypeFromJSONTyped,
    EHopeApprenantSearchTypeToJSON,
} from './EHopeApprenantSearchType';
import type { EListSearchType } from './EListSearchType';
import {
    EListSearchTypeFromJSON,
    EListSearchTypeFromJSONTyped,
    EListSearchTypeToJSON,
} from './EListSearchType';

/**
 * 
 * @export
 * @interface EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria
 */
export interface EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria {
    /**
     * 
     * @type {EListSearchType}
     * @memberof EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria
     */
    searchMode?: EListSearchType;
    /**
     * 
     * @type {EHopeApprenantSearchType}
     * @memberof EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria
     */
    value?: EHopeApprenantSearchType;
    /**
     * 
     * @type {EHopeApprenantSearchType}
     * @memberof EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria
     */
    secondaryValue?: EHopeApprenantSearchType;
}

/**
 * Check if a given object implements the EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria interface.
 */
export function instanceOfEListSearchTypeEHopeApprenantSearchTypeCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EListSearchTypeEHopeApprenantSearchTypeCombinableCriteriaFromJSON(json: any): EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria {
    return EListSearchTypeEHopeApprenantSearchTypeCombinableCriteriaFromJSONTyped(json, false);
}

export function EListSearchTypeEHopeApprenantSearchTypeCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : EListSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : EHopeApprenantSearchTypeFromJSON(json['value']),
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : EHopeApprenantSearchTypeFromJSON(json['secondaryValue']),
    };
}

export function EListSearchTypeEHopeApprenantSearchTypeCombinableCriteriaToJSON(value?: EListSearchTypeEHopeApprenantSearchTypeCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': EListSearchTypeToJSON(value.searchMode),
        'value': EHopeApprenantSearchTypeToJSON(value.value),
        'secondaryValue': EHopeApprenantSearchTypeToJSON(value.secondaryValue),
    };
}

